import React, { Component } from "react";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { WHATSAPP_TEMPLATE_LIST } from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import { FiInfo } from "react-icons/fi";
import { HOST_URL, WhstappAccountList, userProfile } from "../api/Api";
import { Link } from "react-router-dom";
import Delete from "../../UI/Table/compopents/cell/Delete";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";

class WhatsappTemplateList extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    super();

    this.state = {
      userId: user_id,
      token: token,
      setIsLoading: true,
      WhatsappTemplateList: null,
      search: "",
      filterTemplateList: null,
      authenticationButton: '',
      route: "",
      showHealthStatus: false,
      healthStatusData: [],
      errorStatus: false,
      errorMessage: "",
      errorColor: "",
      syncLoading: false,
      showSyncPopup: false,
      brandNumberList: [],
      brandNumberLoading: false,
      selectedBrandNumber: "",
      brandNumberError: ""
    };
    this.searchHandler = this.searchHandler.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    this.getWhatsaAppTemplateList();
    this.getRoute();
  }

  getWhatsaAppTemplateList = async () => {
    this.setState({ setIsLoading: true });
    try {
      const { data } = await api.post(WHATSAPP_TEMPLATE_LIST, {
        token: this.state.token,
        user_id: this.state.userId,
        method: "retrieve",
      });

      if (data.success === true) {
        this.setState({ WhatsappTemplateList: data.data, setIsLoading: false });
      } else {
        this.setState({ setIsLoading: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  searchHandler(e) {
    let searchValue = e.target.value.toString();
    this.setState({
      search: searchValue,
    });
  }

  reset(e) {
    this.setState({
      search: "",
    });
  }

  getRoute = async () => {
    try {
      let paramData = {
        user_id: this.state.userId,
        method: "retrieve",
        token: this.state.token
      }
      let { data } = await Axios.post(`${HOST_URL}/get_user_route.php`, paramData)
      if (data.success) {
        this.setState({ route: data.data });
        this.setState({ authenticationButton: data.data });
      }

    } catch (error) {
      console.log(error)
    }
  }

  handleRedirectWhatsappTemplate = () => {
    if (this.state.route === 36 || this.state.route === 41 || this.state.route === 25) {
      this.props.history.push('/dashboard/create-whatsapp-template-new');
    }
    else {
      this.props.history.push('/dashboard/create-whatsapp-template');
    }
    // Access the history object via this.props
    // this.props.history.push('/dashboard/create-whatsapp-template-new');
  };

  handleRedirectAuthenticationTemplate = () => {
    // Access the history object via this.props
    this.props.history.push(
      "/dashboard/create-whatsapp-template-authentication"
    );
  };

  handleRsdirectCarouselTemplate = () => {
    this.props.history.push('/dashboard/create-whatsapp-carousel-template')
  }

  getBrandNumber = async () => {
    this.setState({ brandNumberLoading: true });
    let paramData = {
      user_id: this.state.userId,
      token: this.state.token,
      method: "retrieve",
    }
    WhstappAccountList(paramData).then((res) => {
      if (res.data.success === true) {
        this.setState({ brandNumberList: res.data.data, brandNumberLoading: false });
      } else {
        this.setState({ brandNumberList: [], brandNumberLoading: false });
      }
    }).catch((err) => {
      console.log(err);
      this.setState({ brandNumberList: [], brandNumberLoading: false });
    });
  };

  openSyncPopup = () => {
    this.setState({ showSyncPopup: true, selectedBrandNumber: "", brandNumberError: "" });
    this.getBrandNumber();
  };

  closeSyncPopup = () => {
    this.setState({ showSyncPopup: false, brandNumberError: "" });
  };

  handleBrandNumberChange = (e) => {
    this.setState({ selectedBrandNumber: e.target.value, brandNumberError: "" });
  };

  handleSyncMetaTemplate = async () => {
    if (!this.state.selectedBrandNumber) {
      this.setState({ brandNumberError: "Please select a brand number." });
      return;
    }
    this.setState({ syncLoading: true, errorMessage: "", errorStatus: false });
    try {
      const profileRes = await userProfile({
        user_id: this.state.userId,
        token: this.state.token,
        method: "retrieve",
      });
      const authkey =
        profileRes?.data?.success === true ? profileRes.data.data[0]?.authkey : null;

      if (!authkey) {
        this.setState({
          errorStatus: true,
          errorColor: "alert alert-danger",
          errorMessage: "Unable to fetch authorization key for sync.",
          showSyncPopup: false,
        });
        return;
      }

      const { data } = await Axios.post(
        "https://console.authkey.io/restapi/wptemplateMigration.php",
        {
          method: "migrate",
          brand_number: this.state.selectedBrandNumber,
        },
        {
          headers: {
            Authorization: "Basic" + " " + authkey,
          },
        }
      );

      if (data.success === true) {
        handleUserLog("", "clicked_meta_template_synced", "whatsapp", "Meta Template Synced Successfully", "Whastapp Template List", "", "");
        this.setState({
          errorStatus: true,
          errorColor: "alert alert-success",
          errorMessage: data.Message || "Templates synced from Meta successfully.",
          showSyncPopup: false,
        });
        setTimeout(() => {
          this.setState({ errorStatus: false, errorMessage: "" });
        }, 5000);
        this.getWhatsaAppTemplateList();

      } else {
        this.setState({
          errorStatus: true,
          errorColor: "alert alert-danger",
          errorMessage: data.Message || "Failed to sync templates from Meta.",
          showSyncPopup: false,
        });
        setTimeout(() => {
          this.setState({ errorStatus: false, errorMessage: "" });
        }, 5000);
      }
    } catch (error) {
      this.setState({
        errorStatus: true,
        errorColor: "alert alert-danger",
        errorMessage: error.response?.data?.Message || error.Message,
        showSyncPopup: false,
      });
      setTimeout(() => {
        this.setState({ errorStatus: false, errorMessage: "" });
      }, 5000);
    } finally {
      this.setState({ syncLoading: false });
      // setTimeout(() => {
      //   this.setState({ errorStatus: false });
      // }, 3000);
    }
  };

  FreshReply = async (id, value) => {
    let data = {
      token: this.state.token,
      user_id: this.state.userId,
      method: "add_freshreply",
      id: id,
      value: value === 0 ? 1 : 0
    }

    try {
      let response = await fetch(`${HOST_URL}/whatsapp_template.php`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      let result = await response.json();
      if (result.success) {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  }

  WHATSAPP_TEMPLATE_LIST_CONST = [
    {
      name: "WID",
      selector: (row) => row.id,
      sortable: true,
      width: "80px",
    },
    {
      name: "Template Name",
      selector: (row) => (
        <div style={{ textAlign: "left" }}> {/* Force left alignment with inline style */}
          {/* Template Name */}
          <div className="text-muted small mt-1" data-toggle="tooltip" title={row.brand_number}>
            {row.brand_number}
          </div>
          <div>
            <button
              type="button"
              className="bg-transparent border-0 font-weight-bold p-0"
              data-toggle="tooltip"
              data-placement="top"
              title={row.temp_name}
            >
              {row.temp_name}
            </button>
          </div>

          {/* Status */}
          <div className="mt-1">
            {row.temp_status === 0 ? (
              <span className="badge bg-success">Pending</span>
            ) : row.temp_status === 1 ? (
              <span className="badge bg-primary">Approved</span>
            ) : row.temp_status === 2 ? (
              <span className="badge bg-info">Draft</span>
            ) : row.temp_status === 5 ? (
              <span className="badge bg-warning">In Review</span>
            ) : row.error_desc_creation === null ? (
              <button
                type="button"
                className="badge bg-danger border-0"
                data-toggle="tooltip"
                data-placement="top"
                title={row.facebook_response}
              >
                Rejected
              </button>
            ) : (
              <button
                type="button"
                className="badge bg-danger border-0"
                data-toggle="tooltip"
                data-placement="top"
                title={row.error_desc_creation}
              >
                Rejected
              </button>
            )}
          </div>

          {/* Created Date */}
          {(row.coupon_code === 1 && row.lto_type === 1) &&
            <div className="text-muted small mt-1" data-toggle="tooltip" title={row.created}>
              <span style={{ fontSize: "12px", color: "orangered" }} > LTO (Limited Time Offer)</span>
            </div>}

          {(row.coupon_code === 1 && row.lto_type === 0) &&
            <div className="text-muted small mt-1" data-toggle="tooltip" title={row.created}>
              <span style={{ fontSize: "12px", color: "orangered" }}>Coupon Code</span>
            </div>}

          <div className="text-muted small mt-1" data-toggle="tooltip" title={row.created}>
            {row.created}
          </div>
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Category",
      selector: (row) => row.temp_category,
      sortable: true,
    },
    {
      name: "Template Type",
      cell: (row) => <span className="text-primary">{row.temp_type}</span>,
      sortable: true,
    },
    {
      name: "Dynamic Content",
      selector: (row) => (row.dynamic_content === 0 ? "No" : "Yes"),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Status",
    //   cell: (row) =>
    //     row.temp_status === 0 ? (
    //       <span className="badge bg-success">Pending</span>
    //     ) : row.temp_status === 1 ? (
    //       <span className="badge bg-primary">Approved</span>
    //     ) : row.temp_status === 2 ? (
    //       <span className="badge bg-info">Draft </span>
    //     ) : row.temp_status === 5 ? (
    //       <span className="badge bg-warning">In Review </span>
    //     ) : row.error_desc_creation === null ? (
    //       <button
    //         type="button"
    //         className="badge bg-danger border-0"
    //         data-toggle="tooltip"
    //         data-placement="top"
    //         title={row.facebook_response}
    //       >
    //         Rejected
    //       </button>
    //     ) : (
    //       <button
    //         type="button"
    //         class="badge bg-danger border-0"
    //         data-toggle="tooltip"
    //         data-placement="top"
    //         title={row.error_desc_creation}
    //       >
    //         Rejected
    //       </button>
    //     ),
    //   sortable: true,
    // },
    // {
    //   name: "Last update",
    //   selector: (row) => (
    //     <button
    //       type="button"
    //       className="bg-transparent border-0"
    //       data-toggle="tooltip"
    //       data-placement="top"
    //       title={row.created}
    //     >
    //       {row.created}
    //     </button>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Action",
      cell: (e) => (
        <>
          {e.temp_status === 1 ? (
            <>
              {e.temp_category === "Authentication" ?
                <Link to={`/dashboard/preview-whatsapp-autentication/${e.id}`}>
                  <span className="badge bg-primary mr-2"> View </span>{" "}
                </Link> : e.temp_type === "Carousel" ?
                  <Link to={`/dashboard/preview-whatsapp-carousel-template/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link> : (e.route_id === 36 || e.route_id === 41) ?
                    <Link to={`/dashboard/preview-whatsapp-template-new/${e.id}`}>
                      <span className="badge bg-primary mr-2"> View </span>{" "}
                    </Link> :
                    <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                      <span className="badge bg-primary mr-2"> View </span>{" "}
                    </Link>

              }
              {(this.state.route === 36 || this.state.route === 41) ?
                <>
                  {e.temp_type === "Carousel" ?
                    <Link to={`/dashboard/preview-whatsapp-carousel-template-copy/${e.id}`}>
                      <span className="badge bg-warning mr-2"> Copy </span>{" "}
                    </Link>
                    :
                    <Link to={`/dashboard/duplicate-whatsapp-template-new/${e.id}`}>
                      <span className="badge bg-warning mr-2"> Copy </span>{" "}
                    </Link>} </> :
                <>
                  {e.temp_type === "Carousel" ?
                    <Link to={`/dashboard/preview-whatsapp-carousel-template-copy/${e.id}`}>
                      <span className="badge bg-warning mr-2"> Copy </span>{" "}
                    </Link>
                    :
                    <Link to={`/dashboard/duplicate-whatsapp-template/${e.id}`}>
                      <span className="badge bg-warning mr-2"> Copy </span>{" "}
                    </Link>}
                </>
              }
              <Delete id={e.id} name={e.temp_name} />
              <span onClick={() => this.checkHealthStatus(e.facebook_tempid)} className="badge bg-info ml-2"> Health Status </span>
            </>
          ) : e.temp_status === 2 ? (
            <>
              {e.temp_category === "Authentication" ?
                <Link to={`/dashboard/preview-whatsapp-autentication/${e.id}`}>
                  <span className="badge bg-primary mr-2"> View </span>{" "}
                </Link> : e.temp_type === "Carousel" ?
                  <Link to={`/dashboard/preview-whatsapp-carousel-template/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link> : (e.route_id === 36 || e.route_id === 41) ?
                    <Link to={`/dashboard/preview-whatsapp-template-new/${e.id}`}>
                      <span className="badge bg-primary mr-2"> View </span>{" "}
                    </Link> :
                    <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                      <span className="badge bg-primary mr-2"> View </span>{" "}
                    </Link>}
              <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                <span className="badge bg-success mr-2"> Edit </span>{" "}
              </Link>
              {/* {(this.state.route === 36 || this.state.route === 41) ? 
               <Link to={`/dashboard/duplicate-whatsapp-template-new/${e.id}`}>
                <span className="badge bg-warning mr-2"> Copy </span>{" "}
              </Link> :
              <Link to={`/dashboard/duplicate-whatsapp-template/${e.id}`}>
                <span className="badge bg-warning mr-2"> Copy </span>{" "}
              </Link>
              } */}
              <Delete id={e.id} name={e.temp_name} />
              <span onClick={() => this.checkHealthStatus(e.facebook_tempid)} className="badge bg-info ml-2"> Health Status </span>
            </>
          ) : e.temp_status === 0 ? (
            <>
              {e.temp_type === "Carousel" ?
                <Link to={`/dashboard/preview-whatsapp-carousel-template/${e.id}`}>
                  <span className="badge bg-primary mr-2"> View </span>{" "}
                </Link> : (e.route_id === 36 || e.route_id === 41) ?
                  <Link to={`/dashboard/preview-whatsapp-template-new/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link> :
                  <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link>}
              <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                <span className="badge bg-success mr-2"> Edit </span>{" "}
              </Link>
              {/* <Link to={`/dashboard/duplicate-whatsapp-template/${e.id}`}>
                <span className="badge bg-warning mr-2"> Copy </span>{" "}
              </Link> */}
              <Delete id={e.id} name={e.temp_name} />
              <span onClick={() => this.checkHealthStatus(e.facebook_tempid)} className="badge bg-info ml-2"> Health Status </span>
            </>
          ) : (
            <>
              {e.temp_type === "Carousel" ?
                <Link to={`/dashboard/preview-whatsapp-carousel-template/${e.id}`}>
                  <span className="badge bg-primary mr-2"> View </span>{" "}
                </Link> : (e.route_id === 36 || e.route_id === 41) ?
                  <Link to={`/dashboard/preview-whatsapp-template-new/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link> :
                  <Link to={`/dashboard/preview-whatsapp-template/${e.id}`}>
                    <span className="badge bg-primary mr-2"> View </span>{" "}
                  </Link>}
              {/* <Link to={`/dashboard/duplicate-whatsapp-template/${e.id}`}>
                <span className="badge bg-warning mr-2"> Copy </span>{" "}
              </Link> */}
              <Delete id={e.id} name={e.temp_name} />
              <span onClick={() => this.checkHealthStatus(e.facebook_tempid)} className="badge bg-info ml-2"> Health Status </span>
            </>
          )}
        </>
      ),
      width: "250px",
    },
    {
      name: "Fresh Reply",
      selector: (row) => (
        row.fresh_reply === 0 ? <span className="badge bg-success" onClick={() => this.FreshReply(row.id, row.fresh_reply)}>Add Fresh Reply</span> :
          <span className="badge bg-danger" onClick={() => this.FreshReply(row.id, row.fresh_reply)}>Remove</span>
      ),
      sortable: true,
    },
  ];

  checkHealthStatus = async (id) => {
    let paramData = {
      user_id: this.state.userId,
      token: this.state.token,
      method: "check_template_status",
      template_id: id,
    }
    try {
      let { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, paramData);
      if (data.success) {
        this.setState({ healthStatusData: data.message })
        this.setState({ showHealthStatus: true })
      }
      else {
        this.setState({
          errorStatus: true,
          errorColor: "alert alert-danger",
          errorMessage: data.message
        })
      }
    } catch (error) {
      this.setState({
        errorStatus: true,
        errorColor: "alert alert-danger",
        errorMessage: error.message
      })
      // console.log(error)
    }
  }

  render() {
    // document.querySelector("body").scrollTo(0, 0);
    //   if(this.state.WhatsappTemplateList){
    // var filteredList = this.state.WhatsappTemplateList.filter(
    //   (item) =>
    //     // console.log(item.temp_name)
    //     item.temp_name.toLocaleLowerCase().includes(this.state.search.toLocaleLowerCase())||
    //     item.id.toString().includes(this.state.search)
    // );}
    const allowedDomains = ["console.authkey.io", "localhost:3000"];
    const currentDomain = window.location.host;
    const showHelpButton = allowedDomains.includes(currentDomain);
    // console.log(this.state.route)
    return (
      <DashboardLayout>
        <main className="content">
          <div className="container-fluid p-0">
            {/* <Title
              isButton={true}
              btnName={`Create New Template`}
              actionURL={`/dashboard/create-whatsapp-template`}
            >
              {" "}
              WhatsApp Template List{" "}
            </Title> */}
            <div className="row">
              {showHelpButton && (
                <div className="col-auto ml-auto text-right mt-n1 mb-2">
                  <a
                    href="https://docs.google.com/document/d/154BE8_nLo1iPubLYNUM2E_dr3q7S9p9hjBY9Fcxvu0o/edit?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button onClick={() => handleUserLog("", "clicked_whatsapp_template_help", "whatsapp", "User Click on Help Button in Whastapp Template List", "Whastapp Template List", "", "")} className="btn btn-primary btn-sm">
                      <FiInfo style={{ fontSize: "18px", marginRight: "2px" }} />
                      Help
                    </button>
                  </a>
                </div>
              )}

            </div>

            <div className="row">
              <div className="col-3">
                <h6>WhatsApp Template List</h6>
              </div>
              <div className="col-9 mb-2">
                <button
                  type="button"
                  style={{ float: "right", fontSize: "12px", padding: "10px 10px 10px 10px" }}
                  onClick={() => {
                    this.handleRedirectWhatsappTemplate();
                    handleUserLog("", "clicked_create_whatsapp_template_button", "whatsapp", "User Click on Create Template Button", "Whastapp Template List", "", "")
                  }}
                  className="btn btn-success"
                >
                  Create New Template
                </button>
                {this.state.authenticationButton === 25 ||
                  this.state.authenticationButton === 36 ||
                  this.state.authenticationButton === 41 ? (
                  <button
                    style={{ float: "right", fontSize: "12px", padding: "10px 10px 10px 10px" }}
                    onClick={() => {
                      this.handleRedirectAuthenticationTemplate();
                      handleUserLog("", "clicked_whatsapp_create_authentication_template", "Whatsapp Template", "User Click on Create Authentication Template Button", "Whastapp Template List", "", "");
                    }}
                    type="button"
                    className="btn btn-info mr-2"
                  >
                    Create Authentication Template
                  </button>
                ) : null}
                <button
                  onClick={() => {
                    this.openSyncPopup();
                  }}
                  disabled={this.state.syncLoading}
                  style={{
                    float: "right",
                    display: "inline-flex", alignItems: "center", gap: "7px",
                    padding: "9px 18px", borderRadius: "10px", marginRight: "8px", marginLeft: "8px",
                    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                    color: "#fff", border: "none", cursor: this.state.syncLoading ? "not-allowed" : "pointer",
                    fontSize: "13px", fontWeight: "600",
                    boxShadow: "0 4px 14px rgba(99,102,241,0.35)",
                    opacity: this.state.syncLoading ? 0.75 : 1,
                  }}
                >
                  {this.state.syncLoading
                    ? <><FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "12px" }} /> Syncing...</>
                    : <><FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: "12px" }} /> Sync Meta Template</>
                  }
                </button>
                {this.state.authenticationButton === 36 || this.state.authenticationButton === 41 ? <button type="button" style={{ float: "right", fontSize: "12px", padding: "10px 10px 10px 10px" }} onClick={() => {
                  this.handleRsdirectCarouselTemplate();
                  handleUserLog("", "clicked_whatsapp_create_carousel_template", "whatsapp", "User Click on Create Carousel Template Button", "Whastapp Template List", "", "")
                }} className="btn btn-danger">Create New Carousel Template</button> : null}
              </div>
            </div>

            {this.state.showHealthStatus && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  backdropFilter: 'blur(5px)',
                  zIndex: 1040 // one less than modal
                }}
              >
                <div
                  className="translate-middle mt-3 p-4 bg-white border border-2 rounded shadow-lg"
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1050,
                    width: '90%',
                    maxWidth: '900px',
                    maxHeight: '80vh',
                    overflowY: 'auto'
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Health Status</h5>
                    <span
                      onClick={() => this.setState({ showHealthStatus: false })}
                      style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                    >
                      &times;
                    </span>
                  </div>

                  <table className="table table-sm table-striped mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Phone Number ID</th>
                        <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Name</th>
                        <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Language</th>
                        <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Status</th>
                        <th style={{ backgroundColor: "#4ec9b0", color: "white" }}>Quality Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{this.state.healthStatusData.id}</td>
                        <td>{this.state.healthStatusData.name}</td>
                        <td>{this.state.healthStatusData.language}</td>
                        <td>{this.state.healthStatusData.status}</td>
                        <td>{this.state.healthStatusData.quality_score.score}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {this.state.showSyncPopup && (
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  backdropFilter: 'blur(5px)',
                  zIndex: 1040
                }}
              >
                <div
                  className="translate-middle mt-3 p-4 bg-white border border-2 rounded shadow-lg"
                  style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1050,
                    width: '90%',
                    maxWidth: '460px',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Sync Meta Template</h5>
                    <span
                      onClick={this.closeSyncPopup}
                      style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                    >
                      &times;
                    </span>
                  </div>

                  <div className="form-group mb-1">
                    <label>
                      Brand Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={`form-control ${this.state.brandNumberError ? "is-invalid" : ""}`}
                      value={this.state.selectedBrandNumber}
                      onChange={this.handleBrandNumberChange}
                      disabled={this.state.brandNumberLoading}
                    >
                      <option value="">
                        {this.state.brandNumberLoading ? "Loading brand numbers..." : "-- Select Brand Number --"}
                      </option>
                      {this.state.brandNumberList.map((item) => (
                        <option key={item.id} value={item.brand_number}>
                          {item.brand_number}
                          {/* {item.comp_name ? `${item.comp_name} (${item.brand_number})` : item.brand_number} */}
                        </option>
                      ))}
                    </select>
                    {this.state.brandNumberError && (
                      <div className="invalid-feedback d-block">{this.state.brandNumberError}</div>
                    )}
                  </div>

                  <div className="d-flex justify-content-end mt-4" style={{ gap: "8px" }}>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={this.closeSyncPopup}
                      disabled={this.state.syncLoading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={this.handleSyncMetaTemplate}
                      disabled={this.state.syncLoading}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "7px",
                        padding: "8px 18px", borderRadius: "8px",
                        background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                        color: "#fff", border: "none", cursor: this.state.syncLoading ? "not-allowed" : "pointer",
                        fontSize: "13px", fontWeight: "600",
                        opacity: this.state.syncLoading ? 0.75 : 1,
                      }}
                    >
                      {this.state.syncLoading
                        ? <><FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "12px" }} /> Syncing...</>
                        : <><FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: "12px" }} /> Sync</>
                      }
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* <div className="input-group pr-3 w-75">
              <input
                type="text"
                
                className="form-control"
                placeholder="Enter template name or WID"
                value={this.state.search}
                onChange={this.searchHandler}
              />
              <div className="input-group-append">
                <button disable style={{ border:"none", paddingLeft:"15px", paddingRight:"15px", cursor:"context-menu"}}><FontAwesomeIcon icon={faSearch} /></button>
              
              </div>
            </div> */}
            {this.state.errorMessage ? (
              <div className={this.state.errorColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{this.state.errorMessage}</div>
              </div>
            ) : null}
            <AdvanceDataTable
              // tableName={"Template List"}
              tableCell={this.WHATSAPP_TEMPLATE_LIST_CONST}
              tableData={this.state.WhatsappTemplateList}
              isLoading={this.state.setIsLoading}
              pagination={true}
            />
          </div>
        </main>
      </DashboardLayout>
    );
  }
}

export default WhatsappTemplateList;
